// ported from resi-search
// @TODO move to contrib

const local = (() => {
  let _store
  let simulateStore = {}
  try {
    _store = window.localStorage
    _store.shared_contrib_test_store = ''
  } catch (e) {
    _store = simulateStore
  }

  return {
    set: (key, value) => {
      _store[key] = JSON.stringify(value)
    },
    get: key => {
      try {
        return JSON.parse(_store[key] || null)
      } catch (e) {
        throw new Error(
          "sessionStore.get: retrieved data that wasn't null and wasn't JSON: " +
            e
        )
      }
    },
    remove: key => {
      if (_store !== simulateStore) {
        _store.removeItem(key)
      } else {
        delete _store[key]
      }
    },
    clear: () => {
      if (_store !== simulateStore) {
        _store.clear()
      } else {
        _store = simulateStore = {}
      }
    },
  }
})()

const cookie = {
  set: (key, value, days, path) => {
    path = path || '/'
    let expires = ''
    if (days) {
      const date = new Date()
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000)
      expires = '; expires=' + date.toGMTString()
    }
    document.cookie = key + '=' + value + expires + '; path=' + path
  },
  get: key => {
    const nameEQ = key + '='
    const ca = document.cookie.split(';')
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i]
      while (c.charAt(0) === ' ') {
        c = c.substring(1, c.length)
      }
      if (c.indexOf(nameEQ) === 0) {
        return c.substring(nameEQ.length, c.length)
      }
    }
    return null
  },
  remove: (key, path) => {
    this.set(key, '', -1, path)
  },
  clear: () => {
    console.error('STUB')
  },
}

module.exports = {
  local,
  cookie,
}
